
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { BlogPost } from "./useBlogPosts";

interface UseBlogPostOptions {
  enabled?: boolean;
}

export function useBlogPost(
  identifier: string, 
  queryType: "id" | "slug" = "id", 
  options: UseBlogPostOptions = {}
) {
  return useQuery({
    queryKey: ["blog-post", queryType, identifier],
    queryFn: async () => {
      try {
        if (!identifier) {
          throw new Error("No post identifier provided");
        }

        // Query the database based on the identifier type (id or slug)
        const { data, error } = await supabase
          .from("blog_posts")
          .select("*")
          .eq(queryType, identifier)
          .single();

        if (error) {
          throw error;
        }

        if (!data) {
          throw new Error(`Post not found with ${queryType} ${identifier}`);
        }

        return data as BlogPost;
      } catch (error: any) {
        console.error("Error fetching blog post:", error);
        toast.error(`Failed to load blog post: ${error.message}`);
        throw error;
      }
    },
    staleTime: 60000, // 1 minute
    enabled: options.enabled !== false && Boolean(identifier), // Allow disabling the query and check for valid identifier
  });
}
